/** Pastille ronde à initiale (serif), comme dans la maquette : sélecteur d'espace, utilisateur, activité. */
export function Avatar({
  initial,
  size = 32,
  tone = 'accent',
  label,
}: {
  initial: string;
  size?: number;
  tone?: 'accent' | 'info' | 'sunken' | 'surface';
  /** Nom accessible ; sans lui l'avatar est décoratif. */
  label?: string;
}) {
  return (
    <span
      className="sh-avatar"
      data-tone={tone}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.5) }}
      {...(label ? { role: 'img', 'aria-label': label, title: label } : { 'aria-hidden': true })}
    >
      {initial}
    </span>
  );
}
